import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { Link, useSearchParams } from 'react-router-dom';
import { useAdminContext } from '../../../context/adminContext';
import { S3_URL } from '../../../utils/BaseUrl';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import LimitPagination from '../../common/LimitPagination';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import Spinwheel from '../../common/Spinwheel';
import CommonTable from '../../common/Table/CommonTable';
import ReactSelect from 'react-select';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import { newCustomerInitialValue, newCustomerValidationSchema } from '../../common/Validation';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { addNewUserApi, otpByPassApi } from '../../../utils/ApiEndpointFunctions';
import ConfirmationModal from '../../common/ConfirmationModal';
import ByPassOtpConfirmationModal from '../../common/Modal/ByPassOtpConfirmationModal';


function CustomerTable(props) {
  const { setConfirmStatus, getUsers, loader, users, selectedPage, page, totalCount, handlePageClick, debouncedOnChange, countryOptions, cityOptions, filterCites, filterCountry, handleCityChange, handleCountryChange, searchFormik } = props;
  const driverBankModal2 = "driverBankModal2"
  const  byPassConfirmModalId = 'byPassConfirmModal'
  const [detailsType,setDetailsType] = useState({type:"",loading:false})
  const {limit, adminDetail} = useAdminContext();
  const imageViewModalId = "imageViewModalId"
   const [activeTab, setActiveTab] = useState('customer');
  const [selectedImg, setSelectedImg] = useState("")
  const confirmApproveOrReject = (status, userId,type,statusType) => {
    setConfirmStatus({ status, userId,type,statusType })
    document.getElementById('confirmModalBtn').click()
  }
  const [selectedCustomer,setSelectedCustomer]= useState({id:"",type:""})

  const headerData = [
    { name: "S.No", className: "col-1", key: "index" },
    { name: "Name", className: "col-4", key: "name" },
      { name: "NIN", className: "col-1", key: "NIN" },  
    { name: "Email ID", className: "col-1", key: "email" },
    { name: "Contact", className: "col-1", key: "phone" },
    { name: "Role", className: "col-1", key: "role" },
    { name: "Parent No", className: "col-1", key: "alternatePhoneNumber" },
    { name: "City", className: "col-1", key: "city" },
    { name: "Account status", className: "col-1", key: "accountStatus" },
    { name: "Login status", className: "col-1", key: "isActive" },
    { name: "Joining Date", className: "col-1", key: "createdAt" },
    { name: "Action", className: "col-1", key: "action" },

  ]

  const handleByPassOtp = async()=>{
    try {
      let res;
     if(selectedCustomer){
       res = await otpByPassApi(selectedCustomer)
     }
      if(res.status===200){
        console.log("resssss??????/",res?.data)
        toast.success(res?.data?.message)
      }
    } catch (error) {
      console.log("error",error)
      toast.error(error?.response?.data?.message)
    }
  }

  const tableData = users.map((item, index) => ({
    index: index+ 1,
    name: (
      <>
        <div className="avatar avatar-xs align-middle me-2">
          <img
            className="avatar-img rounded-circle"
            src={!item.profileImage ? "/images/profiledp.png" : `${S3_URL}/${item?.profileImage}`}
            alt="img"
            data-bs-toggle="modal"
            data-bs-target={`#${imageViewModalId}`}
            style={{ cursor: 'pointer' }}
            onClick={() => { setSelectedImg(!item.profileImage ? "/images/profiledp.png" : `${S3_URL}/${item?.profileImage}`) }}
          />
        </div>
        <Link className="text-primary" to={`/customers/${item.id}`} >{item?.firstName ? capitalizeWords(`${item?.firstName} ${item?.lastName}`) : "-"}</Link>
      </>),
        NIN: item?.NIN || "-", 

    email: item?.email || "-",
    phone: item?.phone || "-",
    role: item?.role ? capitalizeWords(item?.isMinor ? "Minor" : item?.role) : "-",
    alternatePhoneNumber: item?.alternatePhoneNumber || "-",
    city: item?.city || "-",
    createdAt: item?.createdAt ? dateFormat(item?.createdAt) : "-",
    accountStatus: <div className='text-capitalize'>{item?.accountStatus || "-"}</div>,
    isActive: item?.isActive ? "Enabled" : <div className='d-flex flex-column'><span>Disabled</span><span className='fs-5'>({item?.disableReason})</span></div> ,

    action: (
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}
        >
        {item?.accountStatus === "pending" && <li onClick={() => confirmApproveOrReject('approved', item?.id,"approve", "accountStatus")}>
            <a className="dropdown-item" href="#">
              Approve
            </a>
          </li>}
          {item?.accountStatus === "pending" && <li onClick={() => confirmApproveOrReject('rejected',item?.id,"reject", "accountStatus")}>
            <div className="dropdown-item" style={{cursor:"pointer"}} href="#">
              Reject
            </div>
          </li>}
          {/* {item?.accountStatus === "pending" && <li onClick={() => handleByPassOtp(item?.id,item?.role ==="user"?"User":"partnerUser")}>
            <div className="dropdown-item" style={{cursor:"pointer"}} href="#">
              By Pass
            </div>
          </li>} */}

          <li className="dropdown-item" >
            <div
              data-bs-toggle="modal"
              data-bs-target={`#${byPassConfirmModalId}`}
              onClick={() => { setSelectedCustomer({
                id:item?.id,
                type:item?.role ==="user"?"User":"partnerUser"
              }) }}
              style={{ cursor: "pointer" }}
            >
              By Pass Otp
            </div>
          </li>

          {item?.isActive === false && <li
            onClick={() =>
              confirmApproveOrReject('approved', item?.id,"enable","isActive")
            }
          >
            <a className="dropdown-item" href="#">
              Enable
            </a>
          </li>}

          {item?.isActive === true && <li
            onClick={() =>
              confirmApproveOrReject('rejected', item?.id,"disable","isActive")
            }
          >
            <a className="dropdown-item" href="#">
              Disable
            </a>
          </li>}
        </ul>
      </div>
    )
  }))

  useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }

    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);

  function handleInputChange(name, value, formik, input) {
    if (input === "select") {
      formik.setFieldValue(name, value || "");
    } else if (input === "phone") {
      formik.setFieldValue(name, value);
    }
  }


  async function handleCustomerDetailSubmit(payload, apiEndPoint) {
    try {
      console.log("in try block")
      setDetailsType({ ...detailsType, loading: true })
      const res = await apiEndPoint({ ...payload, })
      if (res?.status == 200 || res?.status == 201) {
        getUsers(1,limit)
        document.getElementById(detailsFields[activeTab]?.modalId)?.click()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
    }
    setDetailsType({ ...detailsType, loading: false })
  }

  const typeOptions = [
    { label: "User", value: "User" },
    // { label: "PartnerUser", value: "PartnerUser" }
  ];

  const detailsFields = {
    "customer": {
      format: [
        { name: "type", label: "Type", type: "select", options: typeOptions, handleOnChange: (...values) => handleInputChange(...values, "select") },
        { name: "phone", label: "Phone Number", type: "phone", handleOnChange: (...values) => handleInputChange(...values, "phone") },
      ],
      initialvalue: newCustomerInitialValue,
      validationSchema: newCustomerValidationSchema,
      handleSubmit: (values) => handleCustomerDetailSubmit({...values,type:values?.type?.value}, addNewUserApi),
      modalId: driverBankModal2
              }            
          }

            const customerDetailsFormik = useFormik({
          initialValues:detailsFields?.[activeTab]?.initialvalue,
          validationSchema:detailsFields?.[activeTab]?.validationSchema,
          onSubmit:detailsFields?.[activeTab]?.handleSubmit
      })

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
        <LimitPagination getData={getUsers} />
        <div style={{ display: "-webkit-inline-box" }}>
          <div className="position-relative my-3 d-flex gap-2">

            <div className="d-flex align-items-center gap-2">
              <label htmlFor="city" className="form-label">Country</label>
              <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
              {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
            </div>

            <div className="d-flex align-items-center gap-2">
              <label htmlFor="city" className="form-label">City</label>
              <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
              {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
            </div>

            <div className='d-flex align-items-center gap-2'>
              <button
                className="btn btn-primary"
                onClick={() => { searchFormik.resetForm(); }}
                disabled={!searchFormik?.values?.countryId}
              >
                Reset filter
              </button>
            </div>

            <input
              className="form-search me-3"
              type="search"
              name="searchField"
              id=""
              placeholder="Search"
              onChange={debouncedOnChange}
            // value = {search}
            />
         
           <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`} onClick={() => setActiveTab("customer")} >Add</button>

          </div>
        </div>
      </div>
      <CommonTable headers={headerData} data={tableData} loading={loader} />
      <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />

      {totalCount > limit ? (
        <div className="d-flex justify-content-center">
          <ReactPaginate
            nextLabel="Next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={page}
            previousLabel="< Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName={"active"}
            forcePage={selectedPage - 1}
          />
        </div>
      ) : (
        ""
      )}
        <ByPassOtpConfirmationModal modalId={byPassConfirmModalId} handleConfirm={handleByPassOtp} />
        <AddOrUpdateDetails formik={customerDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />
    </>
  )
}

export default CustomerTable